<template>
    <v-container style="padding-bottom: 7rem;">
        <p class="font-weight-black display-4">Music Never Gets Old<br>With Diffuse</p>
        <p class="font-weight-regular display-1">Live Wallpaper That Shows What You Are Playing In A Fluid-Motion Manner</p>
        <v-dialog
                v-model="downloadDialog"
                width="500">
            <template v-slot:activator="{ on }">
                <v-btn style="z-index: 4" class="mx-2" fixed right bottom dark rounded large v-on="on">
                    <v-icon dark>{{ downloadIcon }}</v-icon>DOWNLOAD
                </v-btn>
            </template>
            <v-card>
                <v-card-title primary-title>
                    Choose Source
                </v-card-title>

                <v-card-text>
                    The old version of Diffuse was removed by Google for no reason (read <a href="https://github.com/FinGameWorks/Changelog/blob/master/NOTICE.md">notice</a> here). As for now, you can either download the new version from a different Google Play developer account (recommended), or from a direct link.
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="downloadApp('play')">
                        Google Play
                    </v-btn>
                    <v-btn color="primary" text @click="downloadApp('portfolio')">
                        Direct Link
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-divider class="divider-extended"></v-divider>
        <p class="font-weight-black display-2">No Longer An Apple Exclusive</p>
        <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
                <p class="font-weight-regular headline">
                    <a class="font-weight-bold" v-on:click="downloadDialog = true">Diffuse</a>
                    brings a feature previously only available on Apple Music, the Dynamic Background (in Live Lyrics), to Android and all mainstream music players. See <router-link to="gallery">the gallery</router-link> for beautiful screenshots!<br>
                    Now you can enjoy similar visuals with <b>Spotify</b>, <b>Tidal</b>, <b>SoundCloud</b> ... on your home screen. And the best part? It packs more feature than the original one with <b>Live Beats</b> and <b>Instagram Stories Share</b> support.
                </p>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="7" xl="7">
                <v-img src="../assets/applevsdiffuse.jpg"></v-img>
            </v-col>
        </v-row>
        <v-divider class="divider-extended"></v-divider>
        <p class="font-weight-black display-2">Watch Trailer</p>
        <div style="width: 100%;">
            <youtube fit-parent resize :video-id="youtubeId" ref="youtube"></youtube>
        </div>
        <v-divider class="divider-extended"></v-divider>
        <p class="font-weight-black display-2">See What It Can Do</p>
        <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card outlined>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="headline">Dynamics Album Art Fluid</v-card-title>
                            <v-card-subtitle>Diffuse extract the album art from current playing music and applies with fluid motions. The fluid never stops, and you can just look at it all-day.</v-card-subtitle>
                        </div>
                        <v-avatar class="ma-3" size="125" tile>
                            <v-img src="../assets/feature_1.jpg"></v-img>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card outlined>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="headline">Live Beats Vibe Visualizer</v-card-title>
                            <v-card-subtitle>Diffuse deploys a beat detection feature that amplifies the fluid motion when the beat drops as if the fluid was being squeezed — prefect for your Android home screen to roll with your music.</v-card-subtitle>
                        </div>
                        <v-avatar class="ma-3" size="125" tile>
                            <v-img src="../assets/feature_2.jpg"></v-img>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card outlined>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="headline">Customizable Graphics</v-card-title>
                            <v-card-subtitle>Change the fluid scale as you like. Preserve album art for the next reboot. And more to come.</v-card-subtitle>
                        </div>
                        <v-avatar class="ma-3" size="125" tile>
                            <v-img src="../assets/feature_3.jpg"></v-img>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
                <v-card outlined>
                    <div class="d-flex flex-no-wrap justify-space-between">
                        <div>
                            <v-card-title class="headline">Social Media Share Support</v-card-title>
                            <v-card-subtitle>Just like the Instagram Stories Share feature in Apple Music, Diffuse also have such share features where you can share your #NowPlaying with fluid background enabled.</v-card-subtitle>
                        </div>
                        <v-avatar class="ma-3" size="125" tile>
                            <v-img src="../assets/feature_4.jpg"></v-img>
                        </v-avatar>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-divider class="divider-extended"></v-divider>
        <p class="font-weight-black display-2">Tech Specs</p>
        <v-expansion-panels hover flat>
            <v-expansion-panel>
                <v-expansion-panel-header>Device Requirement</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <ul>
                        <li>Android 7.0 and up</li>
                        <li>Audio Permission (Optional)</li>
                        <li>Notification Access (Optional)</li>
                    </ul>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Player Requirement</v-expansion-panel-header>
                <v-expansion-panel-content>
                    Known supported players:
                    <ul>
                        <li>Spotify</li>
                        <li>SoundCloud</li>
                        <li>Apple Music</li>
                        <li>Tidal</li>
                        <li>YouTube Music</li>
                        <li>Google Play Music</li>
                        <li>TuneIn Radio</li>
                        <li>QQ Music</li>
                        <li>NetEase Music</li>
                    </ul>
                    If you find your music players not listed, don't worry. Other players haven't been tested, but in theory they should be compatible.<br><br>
                    Except:
                    <ul>
                        <li>Xiami Music</li>
                    </ul>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-container>
</template>

<script>
    import {mdiDownload} from "@mdi/js";
    export default {
        name: "Home",
        head: {
            title: {
                inner: 'Home'
            },
            meta: [
            ],
            link: [
            ]
        },
        mounted: function()
        {
        },
        methods: {
            downloadApp: function (source) {
                if (source === "drive")
                {
                  window.open("https://drive.google.com/file/d/1Cm9CGtNh0YEkJNWGjKUUXxsZAmtQvFs9/view?usp=sharing","_blank");
                }else if (source === "portfolio")
                {
                  window.open("https://portfolio.justzht.com/works/diffuse/diffuse.apk","_blank");
                }else if (source === "play")
                {
                  window.open("https://play.google.com/store/apps/details?id=com.depthware.lwp.diffuse","_blank");
                }
                if (this.downloadDialog === true)
                {
                  this.downloadDialog = false;
                }
            }
        },
        data: function () {
            return {
                downloadDialog: false,
                youtubeId: '6j41so6OTGE',
                downloadIcon: mdiDownload
            }
        }
    }
</script>

<style scoped>
    .divider-extended
    {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
</style>